<template>
  <div class="news-dynamic-container">
    <div class="news-dynamic" v-if="newsList.length > 0">
      <!-- 标题 -->
      <div class="title">
        <h3>公司要闻</h3>
        <span @click="clickMore">查看更多</span>
      </div>

      <!-- 置顶 -->
      <div class="top" v-if="topItem.type === 1" @click="() => clickNews(topItem)">
        <img :src="topItem.photoPath" :alt="topItem.title" />
        <div class="add-time">{{ topItem.addTime | formatTime }}</div>
        <h4>{{ topItem.title }}</h4>
        <p>{{ topItem.artAbstract }}</p>
      </div>
      <a
        class="top"
        v-else-if="topItem.type === 3"
        :href="JSON.parse(topItem.content).link"
        target="_blank"
      >
        <img :src="topItem.photoPath" :alt="topItem.title" />
        <div class="add-time">{{ topItem.addTime | formatTime }}</div>
        <h4>{{ topItem.title }}</h4>
        <p>{{ topItem.artAbstract }}</p>
      </a>

      <!-- 其余4篇 -->
      <ul>
        <li v-for="item in newsList.slice(1)" :key="item.id">
          <div v-if="item.type === 1" @click="() => clickNews(item)" style="display: flex">
            <div v-if="item.photoPath" class="img-box">
              <img :src="item.photoPath" :alt="item.title" />
            </div>
            <div>
              <p class="add-time">{{ item.addTime | formatTime }}</p>
              <p class="item-title">{{ item.title }}</p>
            </div>
          </div>
          <a
            style="display: flex"
            v-else-if="item.type === 3"
            :href="JSON.parse(item.content).link"
          >
            <div v-if="item.photoPath" class="img-box">
              <img :src="item.photoPath" :alt="item.title" />
            </div>
            <div>
              <p class="add-time">{{ item.addTime | formatTime }}</p>
              <p class="item-title">{{ item.title }}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="my-tip" v-else>
      <img :src="nullPng" alt="" />
      <p>当前暂无内容~</p>
    </div>
  </div>
</template>

<script>
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';
import nullPng from '../../../static/image/null.png';

export default {
  name: 'NewsDynamic',
  data() {
    return {
      companyNews: codes.COMPANY_NEWS, // 公司要问
      crassrootsDynamics: codes.GRASSROOTS_DYNAMICS, // 基层动态
      infoDisclosure: codes.INFO_DISCLOSURE, // 信息公开
      newsList: [], // 文章列表
      currentColumn: null, // 当前选中栏目
      clickTag1: codes.MENU, // 标记点击的是菜单
      clickTag2: codes.ARTICLE, // 标记点击的是新闻文章
      nullPng,
    };
  },
  mounted() {
    this.initNews();
  },
  methods: {
    initNews() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      this.$api.postMenuArticle(replacement, [codes.COMPANY_NEWS], 1, 5).then((res) => {
        this.newsList = res.articleList;
      });
    },

    // 点击更多跳转到当前栏目
    clickMore() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuId: codes.COMPANY_NEWS,
      };
      this.$api.getMenuLevels(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, data, this.clickTag1),
        });
      });
    },

    // 点击新闻
    clickNews(articleData) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        articleId: articleData.id,
      };
      // this.$api.countClick(replacement)
      //   .then(data => {
      //     return this.$api.getArticleUpMenus(replacement)
      //   })
      // 获取文章的上级菜单结构
      this.$api.getArticleUpMenus(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, articleData, this.clickTag2),
        });
      });
    },
  },
  computed: {
    topItem() {
      return this.newsList[0];
    },
  },
};
</script>

<style scoped lang="scss">
.news-dynamic-container {
  padding: 0 40px;

  .my-tip {
    height: 100%;
    padding-top: calc-width(84vw);
    text-align: center;
    color: #ababab;
  }

  .news-dynamic {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 60px;
      margin-bottom: 31px;

      h3 {
        font-size: 42px;
        font-weight: 500;
        color: #333333;
        line-height: 59px;
      }

      span {
        font-size: 26px;
        font-weight: 400;
        color: #adadad;
        line-height: 37px;
      }
    }

    .top {
      > img {
        width: 100%;
      }

      > .add-time {
        font-size: 24px;
        font-weight: 400;
        color: #a0a0a0;
        line-height: 33px;
      }

      > h4 {
        font-size: 35px;
        font-weight: 500;
        color: #393939;
        line-height: 49px;
        margin: 23px 0 21px;
      }
      > p {
        font-size: 26px;
        font-weight: 400;
        color: #5f5f5f;
        line-height: 38px;
      }
    }

    > ul {
      margin-top: 40px;
      li {
        padding: 20px 0;
        border-bottom: 1px solid #e4e4e4;

        .img-box {
          width: 190px;
          height: 120px;
          margin-right: 26px;
          img {
            width: 190px;
            height: 120px;
          }
        }

        .add-time {
          font-size: 24px;
          font-weight: 400;
          color: #a0a0a0;
          line-height: 33px;
        }
        .item-title {
          margin-top: 10px;
          font-size: 30px;
          font-weight: 400;
          color: #575757;
          line-height: 37px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/NewsDynamic.vue